import { module } from 'modujs';
import IS_TOUCH_DEVICE from '../app';

export default class extends module {
    constructor(m) {
        super(m);

        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    onFontsLoaded() {
        this.$blackSections = document.querySelectorAll('.js-dark-section');

        function callback(mutationsList, observer) {
            // console.log('Mutations:', mutationsList)
            // console.log('Observer:', observer)
            mutationsList.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                    if (mutation.target.classList.contains('dark-section-inview')) {
                        document.querySelector('html').classList.add('has-dark-background');
                    } else {
                        document.querySelector('html').classList.remove('has-dark-background');
                    }
                }
            })
        }

        const mutationObserver = new MutationObserver(callback)

        this.$blackSections.forEach(($section) => {
            mutationObserver.observe($section, { attributes: true })
        });
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
